import { createElement } from 'react';
import { Input } from '@alifd/next';
import './index.scss';
const ColorfulInput = function ColorfulInput({ color, style = {}, ...otherProps }) {
    const _style = style || {};
    if (color) {
        _style.backgroundColor = color;
    }
    const _otherProps = otherProps || {};
    _otherProps.style = _style;
    return (createElement(Input, { ..._otherProps }));
};
export default ColorfulInput;
